import React from 'react'
import { Link } from 'react-router-dom'
import { BottomMenuItem } from '../types'

interface NavItemProps extends BottomMenuItem {
  isActive: boolean
}

export const NavItem: React.FC<NavItemProps> = ({
  path,
  label,
  icon: Icon,
  unreadCount,
  isActive
}) => {
  return (
    <Link
      to={path}
      className={`flex flex-col items-center py-2 px-3 transition-all duration-300 ${
        isActive ? 'text-blue-600 scale-110' : 'text-gray-600'
      }`}
    >
      <div className="relative">
        <Icon 
          className={`w-6 h-6 transition-colors duration-300 ${
            isActive ? 'text-blue-600' : 'text-gray-600'
          }`} 
        />
        {unreadCount && unreadCount > 0 && (
          <div className="absolute -top-1 -right-1 flex items-center justify-center">
            <div className="animate-ping absolute h-2 w-2 rounded-full bg-red-400 opacity-75"></div>
            <div className="relative h-2 w-2 rounded-full bg-red-500"></div>
          </div>
        )}
      </div>
      <span className={`text-xs mt-1 transition-transform duration-300 ${
        isActive ? 'transform translate-y-0.5' : ''
      }`}>
        {label}
      </span>
    </Link>
  )
} 